
import { defineComponent } from 'vue';
import useUtils from '@/hooks/useUtils';

export default defineComponent({
	props: {
		headers: {
			required: true,
			type: Array as () => string[],
		},
	},
	setup() {
		const { toTitleCase } = useUtils();

		return { toTitleCase };
	},
});
